// EventType.js
export const getEventType = (bowlerQuantity) => {
  const quantity = Number(bowlerQuantity);
  if (quantity === 1) return "Singles";
  if (quantity === 2) return "Doubles";
  return "Team";
};
